/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2026 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2026 - Finnish Meteorological Institute (FMI)
 * Copyright 2026 - The Norwegian Meteorological Institute (MET Norway)
 * */

import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import { HODOGRAPH_COLORS } from './drawUtils';

const getLegendItem = (color: string, text: string): React.JSX.Element => {
  return (
    <Typography
      sx={{
        color: 'geowebColors.typographyAndIcons.text',
        fontSize: '9px',
      }}
      variant="caption"
    >
      <Box
        sx={{
          width: '16px',
          height: '4px',
          backgroundColor: color,
          display: 'inline-block',
          marginRight: '4px',
          marginBottom: '2px',
        }}
      />
      {text}
    </Typography>
  );
};

export const HodographLegend = (): React.ReactElement => {
  return (
    <Stack
      direction="column"
      useFlexGap
      sx={{
        justifyContent: 'center',
        flexWrap: 'wrap',
        paddingLeft: 2,
        paddingTop: 0.5,
      }}
    >
      {getLegendItem(HODOGRAPH_COLORS[0], '0 - 1 km')}
      {getLegendItem(HODOGRAPH_COLORS[1], '1 - 3 km')}
      {getLegendItem(HODOGRAPH_COLORS[2], '3 - 6 km')}
      {getLegendItem(HODOGRAPH_COLORS[3], '6 - 9 km')}
      {getLegendItem(HODOGRAPH_COLORS[4], '9 - 19 km')}
    </Stack>
  );
};
